import { FormControl } from 'structure/staking/components/form/FormControl';
import {
  Input as BaseWebInput,
  InputOverrides,
  InputProps,
} from 'baseui/input';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dapp/multi-lib/sdaoui/Button';

const overrides: InputOverrides = {
  Root: {
    style: () => ({
      borderTopColor: '',
      borderBottomColor: '',
      borderLeftColor: '',
      borderRightColor: '',
      borderTopStyle: 'none',
      borderBottomStyle: 'none',
      borderLeftStyle: 'none',
      borderRightStyle: 'none',

      backgroundColor: '#191A1E',

      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
    }),
  },
  Input: {
    style: ({ $theme, $error }) => ({
      minWidth: '3.375rem',
      fontSize: '0.875rem',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem',
      backgroundColor: '#191A1E',
      color: $error ? '#FB5656' : $theme.colors.white,
      textAlign: 'right',
    }),
  },
};

// type InputLockedPeriodProps = Omit<InputProps, 'min' | 'max'> & {
type InputLockedPeriodProps = Omit<InputProps, 'error' | 'min' | 'max'> & {
  error: string | undefined;
  min?: number | string;
  max?: number | string;
  prefix?: string;
  lockingPeriods: number[];
  onChanePeriod: (value: number) => void;
};

export const InputLockedPeriod = React.forwardRef<
  HTMLInputElement,
  InputLockedPeriodProps
>(function (props, ref) {
  const { lockingPeriods, min, max, error, onChanePeriod, disabled, ...rest } =
    props;

  return (
    <FormControl error={error}>
      <div className='flex flex-row items-center gap-2'>
        <div className='my-3 flex flex-row gap-2'>
          {lockingPeriods.map((period) => {
            return (
              <ButtonPeriod
                key={period}
                prefix={props.prefix}
                active={rest.value === period}
                disabled={disabled}
                onClick={onChanePeriod}
                period={period}
              />
            );
          })}
        </div>
        <BaseWebInput
          min={Number(min) || undefined}
          max={Number(max) || undefined}
          type='number'
          overrides={overrides}
          error={Boolean(error)}
          disabled={disabled}
          {...rest}
          inputRef={ref}
        />
      </div>
    </FormControl>
  );
});

type ButtonPeriodProps = {
  prefix?: string;
  active: boolean;
  period: number;
  disabled?: boolean;
  onClick: (period: number) => void;
};

function ButtonPeriod(props: ButtonPeriodProps) {
  const { t } = useTranslation('common');
  const { active, period, prefix = '', disabled = false, onClick } = props;
  return (
    <Button
      type='button'
      disabled={disabled}
      size='small'
      className='flex flex-row items-end justify-end'
      style={active ? 'outline-dark' : 'neutral-dark'}
      onClick={() => onClick(period)}
    >
      <div className='text-sm'>
        {prefix}
        {period}
      </div>
      &nbsp;
      <div className='mb-px text-[0.6rem] capitalize'>
        {t('day', { count: period })}
      </div>
    </Button>
  );
}
